import React, { useState, memo, useEffect } from 'react';
import { array, bool, func, object, string } from 'prop-types';
import Filters from '../../../../global/modules/checkboxFilters/Filters';
import { FACET_TYPES } from '../../../hooks/useSearchUtils';

function SearchFilters(props) {
    const {
        subFilter,
        controller,
        title,
        filterTitleClass,
        filterBodyClasess,
        isFilterModalOpen,
        setIsFilterModalOpen,
        filterData,
        setFilterData,
        triggerEvents,
    } = props;

    const [clearAll, setIsClearAll] = useState(false);

    const [filterState, setFilterState] = useState(controller?.state);

    useEffect(() => {
        controller.subscribe(onStateChange);
    }, []);

    const onStateChange = () => {
        const state = controller.state;
        setFilterState(state);
    };

    const formattedFilterObj = () => {
        const filter = {};
        filter[subFilter.key] = {
            title: subFilter.label,
            multi: true,
            choices: filterState?.values.map(fltr => {
                return {
                    name: subFilter.type !== FACET_TYPES.NUMERIC_RANGE ? fltr?.value : `${fltr?.start} - ${fltr?.end}`,
                    numberOfResults: fltr?.numberOfResults ? fltr?.numberOfResults : 0,
                    type: subFilter.type,
                    values: { ...fltr }
                };
            })
        };
        return filter;
    };
    const formattedFilter = formattedFilterObj();

    const handleIndividualfilters = currentFilterVal => {
        //setLastChangedFilterVal(currentFilterVal)
        if (currentFilterVal) {
            if (currentFilterVal?.start !== undefined) {
                //means numericrangefilter 
                //TODO make range filter a seperate component
                const selFilter = filterState.values.find(item => item.start === currentFilterVal.start);
                controller.toggleSelect(selFilter);
            } else {
                const selFilter = filterState.values.find(item => item.value === currentFilterVal);
                controller.toggleSelect(selFilter);
            }
        } else {
            controller.deselectAll();
        }
    };

    const handleClearAll = () => {
        controller.deselectAll();
        scrollTo(0, 0);
        // setFilterData(initFilterData(controller.state));
    };

    const getResultQty = () => {
        let qty = 0;
        filterState.values.forEach(item => {
            if (item.state === 'selected') {
                qty += item.numberOfResults;
            }
        });
        return qty;
    };

    const handleShowMoreClick = () => {
        controller.showMoreValues();
    };

    return (
        <Filters
            toggleSelect={handleIndividualfilters} //for setting currently clicked option
            filterTitleClass={filterTitleClass}
            title={title}
            filterBodyClasess={filterBodyClasess}
            modalIsOpen={isFilterModalOpen}
            data={formattedFilter}
            filterData={filterData} //contains all checked options
            setFilterData={setFilterData} //for setting all clicked option
            setModalIsOpen={setIsFilterModalOpen}
            isShowMoreVisible={filterState.canShowMoreValues}
            onShowMoreClick={handleShowMoreClick}
            clearAll={clearAll}
            setIsClearAll={handleClearAll}
            triggerEvents={triggerEvents}

        />
    );
}

export default memo(SearchFilters);
SearchFilters.propsType = {
    subFilter: object,
    controller: object,
    title: string,
    filterTitleClass: string,
    filterBodyClasess: string,
    isFilterModalOpen: bool,
    setIsFilterModalOpen: func,
    filterData: array,
    setFilterData: func,
    triggerEvents: bool,
};
SearchFilters.defaultProps = {
    subFilter: {},
    controller: {},
    title: '',
    filterTitleClass: '',
    filterBodyClasess: '',
    isFilterModalOpen: false,
    setIsFilterModalOpen: () => { },
    filterData: [],
    setFilterData: () => { },
    triggerEvents: false,
};
